var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Axios from 'axios';
// import ApiError from '~/exceptions/apiError'
import { useAuthorizationStore } from '../store/authorization';
import { useAuthStore } from '../store/auth';
var ApiError = /** @class */ (function (_super) {
    __extends(ApiError, _super);
    function ApiError(message, code, data) {
        var _this = _super.call(this, message) || this;
        _this.name = 'ApiError';
        _this.code = code;
        _this.data = data;
        return _this;
    }
    return ApiError;
}(Error));
var instance = Axios.create({
    // 初期共通の設定
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});
var setDomainConfig = function () {
    var currentDomain = window.location.hostname;
    if (currentDomain === 'media.engate.jp') {
        instance.defaults.baseURL = 'https://api.engate.jp/v3';
        instance.defaults.headers.common['X-API-Key'] = 'QNRLdqR1FO4Yg0Vtgfl1B7qM6g0oIBT1XusaivFa';
    }
    else {
        instance.defaults.baseURL = 'https://api.engate.jp/v3';
        instance.defaults.headers.common['X-API-Key'] = 'QNRLdqR1FO4Yg0Vtgfl1B7qM6g0oIBT1XusaivFa'; /*
        instance.defaults.baseURL = 'https://stg.api.engate.site/v3'
        instance.defaults.headers.common['X-API-Key'] = 'gYVyIr2k846i2sogl5csJ1golNlUCo051OhvHg2i' */
    } /*
    if (instance.defaults.withCredentials === undefined) {
      const url = String(instance.defaults.url)
      const baseUrl = instance.defaults.baseURL
      if (!/^https?:\/\//i.test(url) || url.indexOf(baseUrl) === 0) {
        instance.defaults.withCredentials = true
      }
    } */
    instance.defaults.headers.common['X-ENGATE-DOMAIN'] = 'media.engate.jp';
};
setDomainConfig();
instance.interceptors.response.use(function (response) { return response; }, function (error) { return Promise.reject(error); });
instance.interceptors.request.use(function (config) {
    if (!instance.defaults.headers.common) {
        instance.defaults.headers.common = {};
    }
    var authorize = useAuthorizationStore();
    // const auth = sessionStorage.getItem('tkn')
    var configKey = 'Authorization';
    if (authorize.authToken) {
        instance.defaults.headers.common[configKey] = "Bearer ".concat(authorize.authToken);
    }
    if (config.data && 'headers' in config.data) {
        var obj_1 = config.data.headers;
        Object.keys(obj_1).forEach(function (key) {
            config.headers.common[key] = obj_1[key];
        });
    }
    return config;
});
instance.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var authStore, token_1, obj_2, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                authStore = useAuthStore();
                if (!Axios.isAxiosError(error)) return [3 /*break*/, 5];
                if (!(error.message === 'Request failed with status code 401' || error.message === 'Request failed with status code 403')) return [3 /*break*/, 4];
                return [4 /*yield*/, authStore.resetToken()];
            case 1:
                _a.sent();
                token_1 = sessionStorage.getItem('tkn');
                if (!token_1) return [3 /*break*/, 3];
                if (error.config && 'headers' in error.config) {
                    obj_2 = error.config.headers;
                    Object.keys(obj_2).forEach(function (key) {
                        if (key === 'Authorization' && error.config) {
                            error.config.headers.Authorization = "Bearer ".concat(token_1);
                        }
                        else if (error.config) {
                            error.config.headers[key] = obj_2[key];
                        }
                    });
                }
                return [4 /*yield*/, Axios
                        .request(__assign({}, error.config))
                        .then(function (data) { return data; })
                        .catch(function (err) {
                        console.log('catch Error:', err);
                        return Promise.reject(err);
                    })];
            case 2:
                res = _a.sent();
                return [2 /*return*/, res];
            case 3: return [2 /*return*/, Promise.reject(error)];
            case 4: return [2 /*return*/, Promise.reject(error)];
            case 5: return [2 /*return*/, Promise.reject(error)];
        }
    });
}); });
/*
instance.interceptors.response.use(
  (response) => {
    if(response?.data && response?.data.code) {
      const { code, message, data } = response.data
      // 失敗のコードの場合
      if (code && code.charAt(1) === '1') {
        throw new ApiError(message, code, data)
      }
    }
    return response
  },
  error => {
    throw error
  }
) */
export default instance;
/*
const instance = ({ $axios, redirect }) => {
  $axios.interceptors.request.use(async config => {
    if (authStore.token) {
      config.headers.common['Authorization'] = `Bearer ${authStore.token}`
    }
    if (config.data && 'headers' in config.data) {
      const obj = config.data.headers
      Object.keys(obj).forEach((key: string) => {
        config.headers.common[key] = obj[key]
      })
    }
    return config
  })

  $axios.interceptors.response.use(
    (response) => {
      return response
    },
    async (error: AxiosError) => {
      if(Axios.isAxiosError(error)) {
        if(error.message === 'Request failed with status code 401' || error.message === 'Request failed with status code 403') {
          await authStore.resetToken()
          const token = sessionStorage.getItem('tkn')
          if(token) {
            if ('headers' in error.config) {
              const obj = error.config.headers
              Object.keys(obj).forEach((key: string) => {
                if(key === 'Authorization') {
                  error.config.headers['Authorization'] = `Bearer ${token}`
                } else {
                  error.config.headers[key] = obj[key]
                }
              })
            }
            const res = await Axios
              .request({
                ...error.config,
              })
              .then((data) => {
                return data
              })
              .catch((err) => {
                console.log('catch Error:', err)
                return Promise.reject(err)
              })
              return res
          } else {
            return Promise.reject(error)
          }
        } else {
          return Promise.reject(error)
        }
      }
      // return Promise.reject(error)
    }
  )

  $axios.onResponse(response => {
    if(response?.data && response?.data.code) {
      const { code, message, error } = response?.data
      // 失敗のコードの場合
      if (code && code.charAt(1) === '1') {
        throw new ApiError({ code, message, error })
      }
    }
  })

  $axios.onError((error: AxiosError) => {
    // FIXME: statusがundefinedになる？
    const status = error.response?.status
    const data = error.response?.data
    console.log('onErrorResponse:', error)
    if (status === 403) {
      console.error('403', error.config)
      //redirect('/')
    } else if (status === 401) {
      console.error('401', error.config)
      //redirect('/signin/')
    } else if (status === 500) {
      console.error('500', data)
      redirect('/')
    } else if (String(error).indexOf('ログインが必要です') > 0){ // temp
      redirect('/signin/')
    }
  })

}

export default instance
*/ 
